import { render } from "./HeaderLogo.vue?vue&type=template&id=206729c8&scoped=true"
const script = {}

import "./HeaderLogo.vue?vue&type=style&index=0&id=206729c8&scoped=true&lang=css"

import exportComponent from "/usr/app/saas-stack/admin-ui/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-206729c8"]])

export default __exports__